import React from 'react';
import { Box } from '@mui/material';
import { tokens } from '../../theme/tokens';
import { mixWithWhite } from '../../utils/color';

export interface LegendItem {
  key: string;
  label: string;
  /** block: a filled bar · outline: a dashed bar · line / dash: a solid or dashed line */
  swatch: 'block' | 'outline' | 'line' | 'dash';
  color: string;
}

const Swatch: React.FC<{ item: LegendItem }> = ({ item }) => {
  if (item.swatch === 'line' || item.swatch === 'dash') {
    return (
      <Box
        component='span'
        aria-hidden
        sx={{ width: 16, borderTop: `${item.swatch === 'line' ? 2.5 : 2}px ${item.swatch === 'line' ? 'solid' : 'dashed'} ${item.color}` }}
      />
    );
  }
  return (
    <Box
      component='span'
      aria-hidden
      sx={{
        width: 12,
        height: 12,
        borderRadius: '3px',
        boxSizing: 'border-box',
        bgcolor: item.swatch === 'block' ? item.color : mixWithWhite(item.color, 0.93),
        border: item.swatch === 'outline' ? `1.5px dashed ${item.color}` : 'none',
      }}
    />
  );
};

/** The key under a goal chart: a small sample of each mark, then its name. */
export const ChartLegend: React.FC<{ items: LegendItem[] }> = ({ items }) => (
  <Box component='ul' sx={{ m: 0, p: 0, listStyle: 'none', display: 'flex', flexWrap: 'wrap', gap: '6px 16px', fontSize: 12.5, color: tokens.ink3 }}>
    {items.map((item) => (
      <Box component='li' key={item.key} sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
        <Swatch item={item} />
        {item.label}
      </Box>
    ))}
  </Box>
);
